import { useEffect, useRef } from 'react';

export default function LogoScrollBar() {
  const scrollRef = useRef(null);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    let scrollAmount = 0;

    const scrollStep = () => {
      if (scrollContainer) {
        scrollAmount++;
        if (scrollAmount >= scrollContainer.scrollWidth / 2) {
          // reset scroll to create infinite loop effect
          scrollAmount = 0;
        }
        scrollContainer.scrollLeft = scrollAmount;
      }
      requestAnimationFrame(scrollStep);
    };

    const animationId = requestAnimationFrame(scrollStep);

    return () => cancelAnimationFrame(animationId);
  }, []);

  const logos = [
    '/images/logo1.png',
    '/images/logo2.png',
    '/images/logo3.png',
    '/images/logo4.png',
    '/images/logo5.png',
    '/images/logo6.png',
    '/images/logo7.png',
  ];

  // Duplicate logos array to create seamless scroll effect
  const extendedLogos = [...logos, ...logos];

  return (
    <div
      ref={scrollRef}
      style={{
        background: '#fbfcfaff',
        padding: '10px 0',
        overflowX: 'hidden',
        whiteSpace: 'nowrap',
        marginTop: '20px', // space from banner
        cursor: 'default',
      }}
      aria-label="Client logos scrolling bar"
    >
      {extendedLogos.map((logo, index) => (
        <img
          key={index}
          src={logo}
          alt={`client logo ${index + 1}`}
          style={{
            height: '60px',
            margin: '0 20px',
            verticalAlign: 'middle',
            display: 'inline-block',
            userSelect: 'none',
          }}
          draggable={false}
        />
      ))}
    </div>
  );
}
